import MobileDetect from "mobile-detect"

export const mobileDetect = new MobileDetect(window.navigator.userAgent)
